<template>
  <label class="toggle">
    <input type="checkbox" @change="handleToggle" tabindex="0" />
    <div
      class="toggle__display"
      :class="isSecondOptionSelected ? 'first' : 'second'"
    >
      <div class="toggle__background"></div>
      <div class="toggle__button toggle__button--first">
        <FirstIcon />
        <p>{{ firstOption }}</p>
      </div>
      <div class="toggle__button toggle__button--second">
        <SecondIcon />
        <p>{{ secondOption }}</p>
      </div>
    </div>
  </label>
</template>
<script setup>
import { defineAsyncComponent, ref } from "vue";
import { useGlobalStore } from "@/stores/globalStore";

const props = defineProps({
  isSecondOptionSelected: {
    boolean: Boolean,
    default: false,
  },
  checked: {
    type: Boolean,
  },
  firstOption: {
    type: String,
    default: "First option",
  },
  secondOption: {
    type: String,
    default: "Second option",
  },
  firstIconType: {
    type: String,
    required: false,
    default: "",
  },
  secondIconType: {
    type: String,
    required: false,
    default: "",
  },
});

const emit = defineEmits(["update:checked"]);

const globalStore = useGlobalStore();
const checked = ref(props.checked);

const handleToggle = (e) => {
  emit(`update:checked`, e.target.checked);
};

const FirstIcon = defineAsyncComponent(() =>
  import(
    /* @vite-ignore */ `../../../components/icons/${props.firstIconType}.vue`
  )
);

const SecondIcon = defineAsyncComponent(() =>
  import(
    /* @vite-ignore */ `../../../components/icons/${props.secondIconType}.vue`
  )
);
</script>
<style lang="scss">
.toggle {
  width: 100%;
  display: block;
  cursor: pointer;
  margin-bottom: 3.2rem;

  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
  }

  &__display {
    display: flex;
    border-radius: $border-radius;
    position: relative;
    overflow: hidden;
    background: var(--input-background);
  }

  &__button {
    width: 50%;
    padding: 2rem;
    text-align: center;
    position: relative;
    transition: opacity 250ms;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: $padding-sml;
    transition: var(--toggle-icon-transition);

    &--first {
      .second & {
        p {
          // color: $white;
          color: var(--toggle-text-color-second);
        }

        path {
          // stroke: $white;
          stroke: var(--toggle-text-color-second);
          transition: var(--toggle-icon-transition);
        }
      }

      .first & {
        p {
          color: $black;
          color: var(--toggle-text-color-first);
        }

        path {
          stroke: var(--toggle-text-color-first);
          transition: var(--toggle-icon-transition);
        }
      }
    }

    &--second {
      .first & {
        p {
          color: var(--toggle-text-color-second);
        }

        path {
          stroke: var(--toggle-text-color-second);
          transition: var(--toggle-icon-transition);
        }
      }

      .second & {
        p {
          color: var(--toggle-text-color-first);
        }

        path {
          stroke: var(--toggle-text-color-first);
          transition: var(--toggle-icon-transition);
        }
      }
    }

    p {
      font-weight: 500;
    }
  }

  &__background {
    width: 50%;
    height: 100%;
    position: absolute;
    background: var(--gradient);
    z-index: 0;
    transition: var(--toggle-background-transition);

    .first & {
      transform: translateX(0);
    }

    .second & {
      transform: translateX(100%);
    }
  }
}
</style>
